import { Box, Button, Container, CssBaseline, Typography } from '@mui/material'
import React from 'react'
import { Navigate } from 'react-router'
import { AuthState } from 'redux/modules/auth'

type OwnProps = {
  auth: AuthState
  onResend: () => void
  onLogOut: () => void
}

const EmailVerification = (props: OwnProps) => {
  const { auth, onResend, onLogOut } = props
  const { user, sendingEmail, loggingOut, logOutError } = auth

  if (!user) {
    return <Navigate replace to="/login" />
  }

  const isNewUser = user.createdAt === user.updatedAt

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          textAlign: 'center',
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Typography component="h1" variant="h4">
          こんにちは、{user.name} さん。
        </Typography>
        <Box
          sx={{
            mt: 2,
          }}>
          <Typography color="textPrimary" component="p">
            {user.email}
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 1,
          }}>
          <Typography color="textSecondary" component="p">
            登録メールアドレスに確認メールを送信しました。
          </Typography>
          <Typography color="textSecondary" component="p">
            メール内のリンクを開いて本登録を完了してください。
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 3,
          }}>
          <Typography color="textSecondary" component="p">
            メールが届きませんか？
          </Typography>
          <Button
            variant="contained"
            color="primary"
            disabled={sendingEmail}
            sx={{ width: 100, mb: 1 }}
            onClick={() => onResend()}>
            再送信
          </Button>
          {sendingEmail && (
            <Typography color="secondary" component="p">
              メールを再送信しました。
            </Typography>
          )}
        </Box>
        {isNewUser && (
          <Box
            sx={{
              mt: 3,
            }}>
            <Typography color="textSecondary" component="p">
              メールアドレスを間違えた場合は再度サインアップする必要があります。
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              disabled={loggingOut}
              sx={{ width: 100, mb: 1 }}
              onClick={() => onLogOut()}>
              ログアウト
            </Button>
            {logOutError && (
              <>
                <Typography color="secondary" component="p">
                  {logOutError}
                </Typography>
                <Typography color="secondary" component="p">
                  解決できない場合は Cookie の削除などを行ってください。
                </Typography>
              </>
            )}
          </Box>
        )}
        {!isNewUser && (
          <Box
            sx={{
              mt: 3,
            }}>
            <Typography color="textSecondary" component="p">
              メールアドレスを間違えた場合は，前のメールアドレスに届くメール内のリンクを開いて，ログイン用メールアドレスをリセットしてください。
            </Typography>
          </Box>
        )}
      </Box>
    </Container>
  )
}

export default EmailVerification
